import { useTranslation } from 'react-i18next'
import styles from './AddUpdateOrdersTestments.module.css'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { axiosConfig } from 'utils/axiosConfig'
import ReactLoading from "react-loading";
import { Container } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid';

const TESTMENT_MODEL = (testment:any)=>{
  return{
      id:uuidv4(),
      name:testment?.name||'',
      receivedCount:testment?.receivedCount||'',
  }
}
function AddUpdateOrdersTestments() {
  const {t} =useTranslation()
  const params = useParams()
  const navigate = useNavigate()
  const [name,setName] =useState('')
  const [receivedCount,setReceivedCount] =useState('')
  const [isLoading,setIsLoading] =useState(false)
  const [testments,setTestments] =useState<any>([TESTMENT_MODEL({})])

  function addTestment(){
      let testmentData = [...testments]
      testmentData.push(TESTMENT_MODEL({}))
      setTestments(testmentData)
  }
  function removeTestment(id:any){
      let testmentData = [...testments]
      testmentData =testmentData.filter(testment=>testment?.id !=id)
      setTestments(testmentData)
  }
  function handleChangeTestmentData(key:any,value:any,index:any){
      let testmentData = [...testments]
      testmentData[index][key] = value
      setTestments(testmentData)
  }

  
  function validateInputs(){
    let status =true
    // if(!name){
    //   toast.error(t('Testment Name Is Required'))
    //   status=false
    // }
    // if(!receivedCount){
    //   toast.error(t('Testment Received Count Is Required'))
    //   status=false
    // }
    return status
  }

  function addUpdateItem(){
    if(!validateInputs()){
      return
    }
    setIsLoading(true)
    const formData  = new FormData()
    testments?.forEach((testment:any,index:number)=>{
      formData.append(`testments[${index}][name]`,testment?.name)
      formData.append(`testments[${index}][received_count]`,testment?.receivedCount)
    })
    
    axiosConfig.post(`/orders/add-testments-to-order/${params?.id}`,formData,{
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }).then(res=>{
      setIsLoading(false)
      toast.success(t(`Order Testment Added Successfully`))
      navigate(`/orders/order-testments/${params?.id}`)
    }).catch(err=>{
      setIsLoading(false)
      toast.error(t('Something went wrong'))
    })
  }

  return (
    <>
      <section className={styles['form-wrapper']}>
        <Container>
          <div className={styles['form__content-wrapper']}>
            <h1 className={styles['form__content-title']}>{t('Add Testaments')}</h1>
            <form className={styles['form__content-form']}>
              
            <div className='w-100 mb-4 d-flex'>
                {/* <label className='fs-5 text-muted mb-0' htmlFor='status'>{t('Testaments')}</label> */}
                <button type='button' onClick={addTestment} className='btn btn-success ms-auto'>{t('Add Testment')}</button>
            </div>
            {
                testments&&testments?.map((testment:any,index:any)=>(
                  <div className={styles['form__content-form-inputs-wrapper']} key={testment?.id}>
                    
                    <input 
                      type='text'
                      className={styles['form__content-form-input']}
                      placeholder={`${t('Name')}`}
                      name={'name'}
                      value={testment?.name}
                      onChange={(e)=>handleChangeTestmentData(e.target.name,e.target.value,index)}
                      
                    />
                      
                      <input 
                        type='number'
                        className={styles['form__content-form-input']}
                        placeholder={`${t('Received Count')}`}
                        name={'receivedCount'}
                        value={testment?.receivedCount}
                        onChange={(e)=>handleChangeTestmentData(e.target.name,e.target.value,index)}
                      />
                      <button type='button' onClick={()=>{removeTestment(testment?.id)}}
                      className='btn btn-danger ms-auto my-2 mb-5'>{t('Remove Testment')}</button>
                  </div>
                ))
            }
              
              <button 
                type='button' 
                className={styles['form__content-form-submit']}
                onClick={addUpdateItem} 
                disabled={isLoading}>
                {
                  !isLoading?t('Add Testaments')
                  :<ReactLoading type={"spin"} color={'#ffffff'} height={30} width={30} />
                }
              </button> 
            </form>
          </div>
        </Container>
        
      </section>
    </>
  )
}

export default AddUpdateOrdersTestments